
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/testimonials/[slug]",
      function () {
        return require("private-next-pages/testimonials/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/testimonials/[slug]"])
      });
    }
  